import { c as _c } from "react/compiler-runtime";
import { aspectOf, focalPoint, type ImageBlock } from "@modules/homepage-v2/lib/getSections";
import Image from "next/image";

/**
 * Every picture a v2 section draws from a `blocks-v2.image`.
 *
 * It exists because the block has four fields and each section used to read a different
 * subset of them: only the hero honoured all four, two sections shipped no `sizes` at all,
 * and a ratio an editor set could come out square. A field the CMS offers has to mean the
 * same thing wherever it is filled in, and that only holds if one place reads it.
 *
 * What stays with the section is where the picture sits: its column, its width, its corners.
 * What the picture *is* — proportions, crop, focal point — comes from the block.
 */
const SectionImage = t0 => {
  const $ = _c(15);
  const {
    image,
    sizes,
    ratio,
    className: t1,
    priority: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const priority = t2 === undefined ? false : t2;
  const media = image?.media?.data?.attributes;
  if (!media?.url) {
    return null;
  }
  const cover = image?.fit !== "contain";
  const t3 = media.url;
  const t4 = media.alternativeText ?? "";
  const t5 = media.width ?? 1200;
  const t6 = media.height ?? 900;
  let t7;
  if ($[0] !== image || $[1] !== ratio) {
    t7 = aspectOf(image, ratio);
    $[0] = image;
    $[1] = ratio;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const t8 = `block w-full ${t7} ${cover ? "object-cover" : "object-contain"} ${className}`;
  let t9;
  if ($[3] !== cover || $[4] !== image) {
    t9 = cover ? {
      objectPosition: focalPoint(image)
    } : undefined;
    $[3] = cover;
    $[4] = image;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== media.url || $[7] !== priority || $[8] !== sizes || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t8 || $[13] !== t9) {
    t10 = <Image src={t3} alt={t4} width={t5} height={t6} sizes={sizes} priority={priority} className={t8} style={t9} />;
    $[6] = media.url;
    $[7] = priority;
    $[8] = sizes;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};
export default SectionImage;